export const contentStyle = {
  overlay: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(172, 173, 185, 0.75)',
    zIndex: 1000000000,
  },
  content: {
    position: 'absolute',
    maxWidth: '67.rem',
    border: 'none',
    backgroundColor: '#f0f4fc',
    borderRadius: '1rem',
  },
};
